<template>
    <div class="databar">
        <div class="topbar">
            <h2>Чаты</h2>

            <div>
                <button @click="newChat" class="newChatButton">
                    <IconPlus />
                </button>

                <button class="closeMenuButton" @click="closeMenu">
                    <IconX />
                </button>
            </div>
        </div>

        <div class="search">
            <div class="search-input">
                <IconSearch class="search-icon" />
                <input type="text" v-model="searchTerm" placeholder="Поиск..." @keyup="searchHandler">
            </div>
        </div>

        <div class="chats" v-if="chats.length > 0">
            <router-link v-for="chat in chats" :key="chat.id" :to="`/chat/${chat.chat_id}`">
                <ChatItemComponent @click="closeMenu" icon="https://random.imagecdn.app/500/500"
                    :title="truncate(chat.title)" :recentMessage="formatDate(chat.created_at)" :chatId="chat.chat_id" />
            </router-link>
        </div>
        <div v-else>
            <p class="noChats">Нет чатов</p>
        </div>
    </div>
</template>

<script>
import ChatItemComponent from "@/components/ChatItemComponent.vue";
import { IconPlus, IconSearch, IconX } from '@tabler/icons-vue';

export default {
    name: 'DatabarComponent',
    components: {
        IconPlus,
        IconSearch,
        IconX,
        ChatItemComponent
    },
    data() {
        return {
            chats: [],
            searchTerm: ''
        }
    },
    methods: {
        newChat() {
            this.$router.push(`/`);
            // this.$api.createChat().then((chatId) => {
            //     this.$router.push(`/chat/${chatId}`);
            //     this.loadChats();
            // });
        },

        truncate(txt) {
            if (txt.length > 30) {
                return txt.substring(0, 30) + '...'
            }

            return txt;
        },

        loadChats() {
            this.$api.getChats().then(chats => {
                this.chats = chats;
            });
        },

        formatDate(timestamp) {
            const date = new Date(timestamp);

            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');

            return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
        },

        closeMenu() {
            if (window.innerWidth < 810) {
                this.$emit('menuClose');
            }
        },

        searchHandler() {
            if (this.searchTerm.length >= 1) {
                // Filtering chats by title or creation date based on search term
                this.chats = this.chats.filter(item =>
                    item.title.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
                    item.created_at.includes(this.searchTerm)
                );
            } else if (this.searchTerm.length === 0) {
                // If search term is empty and no chats, load chats
                this.loadChats();
            }
        },
    },

    mounted() {
        this.loadChats()
    }
}
</script>

<style scoped>
.databar {
    display: flex;
    flex-direction: column;
    background-color: var(--color-secondary);
    border-right: 1px solid var(--color-border);
    height: 100vh;
    width: 350px;
    z-index: 99999;
}

.noChats {
    text-align: center;
    margin-top: 40px;
}

.topbar {
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-top: 16px;
    padding: 14px;
}

.closeMenuButton {
    display: none;
}

.search {
    padding: 8px 14px 14px 14px;
}

.search-input {
    width: 100%;
    background-color: var(--background-color);
    border: 1px solid var(--color-border);
    border-radius: var(--default-border-radius);
    display: flex;
}

.search-input input {
    width: 100%;
    background-color: transparent;
    color: var(--color-text-secondary);
    padding: 12px;
    font-size: 16px;
    border: none;
}

.search-input input:focus {
    outline: none;
}

.search-icon {
    color: var(--color-text-secondary);
    margin-top: 10px;
    margin-left: 12px;
    width: 20px;
}

.chats {
    margin: 20px;
    overflow-y: auto;
}

.newChatButton {
    margin-right: 4px;
}

button {
    font-size: 32px;
    width: 40px;
    height: 40px;
    padding: 0;
}

@media only screen and (max-width: 810px) {
    .databar {
        width: 100%;
    }

    .closeMenuButton {
        display: inline;
    }
}
</style>